(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8467],{

/***/ 72238:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/post/[title]",
      function () {
        return __webpack_require__(39325);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.tsx




// next

// @mui

function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        })
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "text.primary",
                "& > div": {
                    display: "inherit"
                }
            },
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.tsx




// @mui

//

function HeaderBreadcrumbs(_param) {
    var links = _param.links, action = _param.action, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "action",
        "heading",
        "moreLink",
        "sx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            mb: 5
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1
                        },
                        children: [
                            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                gutterBottom: true,
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                                links: links
                            }, other))
                        ]
                    }),
                    action && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0
                        },
                        children: action
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    rel: "noopener",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        rel: "noopener",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 39325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ BlogPost; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40549);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96259);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10901);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61582);
/* harmony import */ var _components_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96339);
/* harmony import */ var _components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82485);
/* harmony import */ var _sections_blog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16225);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20474);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28821);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89419);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
// @mui




// routes

// hooks

// layouts

// components



// sections






// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        paddingTop: theme.spacing(8)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11)
    });
});
// ----------------------------------------------------------------------
BlogPost.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
// ----------------------------------------------------------------------
function BlogPost(param) {
    var _post = param.post, post = _post === void 0 ? null : _post, _morePosts = param.morePosts, morePosts = _morePosts === void 0 ? [] : _morePosts, globalSetting = param.globalSetting, _seoMetadataItemsCollection = param.seoMetadataItemsCollection, seoMetadataItemsCollection = _seoMetadataItemsCollection === void 0 ? [] : _seoMetadataItemsCollection, _callToActionLink = param.callToActionLink, callToActionLink = _callToActionLink === void 0 ? null : _callToActionLink;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), logo = ref7.logo, rootTitle = ref7.title, host = ref7.host;
    var ref8 = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)(), locale = ref8.locale, query = ref8.query, replace = ref8.replace;
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().themeStretch;
    var paramTitle = query.title;
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if ((post === null || post === void 0 ? void 0 : post.title) && post.title !== paramTitle) {
            replace({
                pathname: "/post/".concat(post.title)
            }, undefined, {
                shallow: true
            });
        }
    }, [
        post
    ]);
    var ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: (ref9 = post === null || post === void 0 ? void 0 : post.title) !== null && ref9 !== void 0 ? ref9 : "",
        description: (post === null || post === void 0 ? void 0 : (ref = post.content) === null || ref === void 0 ? void 0 : ref.json) ? (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_10__/* .documentToPlainTextString */ .a)((ref1 = post.content) === null || ref1 === void 0 ? void 0 : ref1.json).slice(250) : undefined,
        metadataItems: seoMetadataItemsCollection,
        openGraphImage: {
            url: (ref10 = post === null || post === void 0 ? void 0 : post.previewUrl) !== null && ref10 !== void 0 ? ref10 : "",
            alt: (ref11 = post === null || post === void 0 ? void 0 : post.title) !== null && ref11 !== void 0 ? ref11 : ""
        },
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: post === null || post === void 0 ? void 0 : post.title,
            inLanguage: locale,
            url: "https://".concat(host, "/").concat(locale, "/post/").concat(post === null || post === void 0 ? void 0 : post.title),
            "@id": "https://".concat(host, "/").concat(locale, "/post/").concat(post === null || post === void 0 ? void 0 : post.title),
            image: (ref12 = (post === null || post === void 0 ? void 0 : post.previewUrl) || (post === null || post === void 0 ? void 0 : post.coverUrl) || logo) !== null && ref12 !== void 0 ? ref12 : "",
            datePublished: (ref13 = post === null || post === void 0 ? void 0 : post.publishedAt) !== null && ref13 !== void 0 ? ref13 : "",
            description: (post === null || post === void 0 ? void 0 : (ref2 = post.content) === null || ref2 === void 0 ? void 0 : ref2.json) ? (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_10__/* .documentToPlainTextString */ .a)((ref3 = post.content) === null || ref3 === void 0 ? void 0 : ref3.json).slice(250) : undefined,
            author: {
                "@type": "Person",
                name: post === null || post === void 0 ? void 0 : (ref4 = post.author) === null || ref4 === void 0 ? void 0 : ref4.name
            },
            publisher: {
                "@type": "Organization",
                name: rootTitle !== null && rootTitle !== void 0 ? rootTitle : "",
                logo: {
                    "@type": "ImageObject",
                    url: logo !== null && logo !== void 0 ? logo : ""
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                maxWidth: themeStretch ? false : "lg",
                sx: {
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        links: [
                            {
                                name: "Blogs",
                                href: _routes_paths__WEBPACK_IMPORTED_MODULE_1__/* .PATH_PAGE.blog */ .ko.blog
                            },
                            (post === null || post === void 0 ? void 0 : post.categories[0]) ? {
                                name: (ref14 = post === null || post === void 0 ? void 0 : post.categories[0]) !== null && ref14 !== void 0 ? ref14 : "",
                                href: "".concat(_routes_paths__WEBPACK_IMPORTED_MODULE_1__/* .PATH_PAGE.blogCategory */ .ko.blogCategory, "/").concat(post === null || post === void 0 ? void 0 : post.categories[0])
                            } : undefined,
                            {
                                name: (ref15 = post === null || post === void 0 ? void 0 : post.title) !== null && ref15 !== void 0 ? ref15 : ""
                            }, 
                        ].filter(_utils_common__WEBPACK_IMPORTED_MODULE_15__/* .notEmpty */ .D)
                    }),
                    post && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog__WEBPACK_IMPORTED_MODULE_7__/* .BlogPostHero */ .pi, {
                                post: post
                            }),
                            Boolean(post.tags.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                sx: {
                                    px: {
                                        xs: 3,
                                        md: 5
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog__WEBPACK_IMPORTED_MODULE_7__/* .BlogPostTags */ .j6, {
                                    post: post
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                sx: {
                                    p: {
                                        xs: 3,
                                        md: 5
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog__WEBPACK_IMPORTED_MODULE_7__/* .BlogPostBody */ .jy, {
                                    content: post.content
                                })
                            }),
                            (callToActionLink || (globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.callToActionLink)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        sx: {
                                            p: {
                                                xs: 3,
                                                md: 5
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            size: "large",
                                            variant: "contained",
                                            target: "_blank",
                                            rel: "noopener",
                                            href: (ref17 = (ref16 = callToActionLink === null || callToActionLink === void 0 ? void 0 : callToActionLink.link) !== null && ref16 !== void 0 ? ref16 : globalSetting === null || globalSetting === void 0 ? void 0 : (ref5 = globalSetting.callToActionLink) === null || ref5 === void 0 ? void 0 : ref5.link) !== null && ref17 !== void 0 ? ref17 : "",
                                            children: (ref18 = callToActionLink === null || callToActionLink === void 0 ? void 0 : callToActionLink.title) !== null && ref18 !== void 0 ? ref18 : globalSetting === null || globalSetting === void 0 ? void 0 : (ref6 = globalSetting.callToActionLink) === null || ref6 === void 0 ? void 0 : ref6.title
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !post && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton__WEBPACK_IMPORTED_MODULE_5__/* .SkeletonPost */ .VJ, {}),
                    Boolean(morePosts.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog__WEBPACK_IMPORTED_MODULE_7__/* .BlogPostRecent */ ._Y, {
                        posts: morePosts
                    })
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,2679,6894,3895,8112,2158,8424,6755,3907,2575,1923,5100,9774,2888,179], function() { return __webpack_exec__(72238); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);